import { render } from "./PrintArea.vue?vue&type=template&id=5e495aff&scoped=true"
import script from "./PrintArea.vue?vue&type=script&lang=js"
export * from "./PrintArea.vue?vue&type=script&lang=js"

import "./PrintArea.vue?vue&type=style&index=0&id=5e495aff&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e495aff"

export default script